import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { requestUserPasswordResetToken, resetPasswordTokenForm } from '../../../../actions/user';
import { forceValidation, clearAllValidationErrors } from '../../../../businessLogic/validation.js';
import { updateShowResetPasswordTokenModal } from '../../../../actions/modal';
const RightPanelResetPasswordToken = (props) => {
  const dispatch = useDispatch();
  const [resetButtonClasses, setResetButtonClasses] = useState(
    'ui labeled icon button icon color-button color-button-hover color-white  max-width left-text mrlnull mrbnull disable'
  );
  const resetPasswordFromRedux = useSelector((state) => state.usersReducer.resetPassword);

  useEffect(() => {
    if (props.resetingPassword == true) {
      setResetButtonClasses(resetButtonClasses + ' loading');
    } else {
      setResetButtonClasses(resetButtonClasses.replace(' loading'));
    }
  }, [props.resetingPassword]);

  const requestNewPassword = (e) => {
    let areThereErrors = forceValidation(undefined, undefined, 'resetPasswordTokenForm');
    let cb = () => {
      cancelResetPassword();
    };
    if (!areThereErrors && !window.$(e.target).hasClass('disable')) {
      dispatch(requestUserPasswordResetToken(resetPasswordFromRedux, cb));
    }
  };
  const cancelResetPassword = () => {
    history.pushState(null, '', location.href.split('?')[0]); //clearing the query string for change password
    resetForm();
    dispatch(updateShowResetPasswordTokenModal(false));
  };

  const resetForm = () => {
    setTimeout(() => {
      dispatch(resetPasswordTokenForm());
    }, 100); //wait until modal is inviisble
  };
  let cancelClassName =
    'ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrlnull mrbnull mrtsss';
  return (
    <div>
      <div className="ui actions mrbl max-width mrtxs">
        <button
          tabIndex="3"
          type="button"
          onClick={requestNewPassword}
          data-group="resetPasswordTokenForm"
          className={resetButtonClasses}
        >
          <i className="checkmark icon" />
          {APP.LANGUAGE.ResetPassword.Ok}
        </button>
        <button
          tabIndex="4"
          type="button"
          onClick={cancelResetPassword}
          className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrlnull mrbnull mrtsss ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrlnull mrbnull mrtm"
        >
          <i className="remove  icon" />
          {APP.LANGUAGE.Cancel}
        </button>
      </div>
    </div>
  );
};
export default RightPanelResetPasswordToken;
